import React, { Component } from 'react';

import { Route, Switch } from 'react-router-dom';

import { Header } from './components/Header/index';
import { Footer } from './components/Footer/index';
import { HomePage } from './screens/HomePage/index';
import { Contact } from './screens/Contact/index';
import { Career } from './screens/Career/index';
import { Call } from './screens/Call/index';
import { JobDetails } from './screens/JobDetails/index';

import './App.scss';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-92053998-1'); // Unique Google Analytics tracking number

class App extends Component {
  render() {
    return [
      <Header key={0} {...this.props} />,
      <Switch key={1}>
        <Route exact path="/" component={HomePage} />
        <Route path="/contact" component={Contact} />
        <Route path="/job-details/:id" component={JobDetails} />
        <Route path="/career" component={Career} />
        <Route path="/call" component={Call} />
      </Switch>,
      <Footer key={2} />
    ];
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js